// extracted by mini-css-extract-plugin
export default {"statRow":"RetentionPage_statRow__aFCr4","chartRow":"RetentionPage_chartRow__xMLDO"};